import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { TransactionProvider } from './context/TransactionContext'

import App from './App';
import './index.css';

ReactDOM.render(
  <TransactionProvider>
  <Router>
    <App />
  </Router>
  </TransactionProvider>,
  document.getElementById('root'),
);
